import { render } from "./posmodal.vue?vue&type=template&id=c8576e38"
const script = {}

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__